"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentFeatureList = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
require("@/components/common");
const common_1 = require("@/components/common");
/**
 * 컴포넌트 문서 페이지의 mm-feature 목록 칼럼 레이아웃을 소유한다.
 */
let ComponentFeatureList = class ComponentFeatureList extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.features = [];
    }
    render() {
        return (0, lit_1.html) `
      <mm-feature-group columns="2">
        ${this.features.map(feature => (0, lit_1.html) `
            <mm-feature
              heading=${feature.heading}
              description=${feature.description}
              icon=${common_1.ICON_NAMES.INFO}
            >
              ${this.renderRules(feature.rules)}
            </mm-feature>
          `)}
      </mm-feature-group>
    `;
    }
    renderRules(rules) {
        if (!rules?.length)
            return lit_1.nothing;
        return (0, lit_1.html) `
      <mm-text-list .texts=${rules}></mm-text-list>
    `;
    }
};
ComponentFeatureList.styles = (0, lit_1.css) `
    :host {
      display: block;
    }
  `;
__decorate([
    (0, decorators_js_1.property)({ attribute: false })
], ComponentFeatureList.prototype, "features", void 0);
ComponentFeatureList = __decorate([
    (0, decorators_js_1.customElement)('mm-component-feature-list')
], ComponentFeatureList);
exports.ComponentFeatureList = ComponentFeatureList;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29tcG9uZW50LWZlYXR1cmUtbGlzdC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbImNvbXBvbmVudC1mZWF0dXJlLWxpc3QudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUEsNkJBQW9EO0FBQ3BELHFEQUEyRDtBQUUzRCwrQkFBNEI7QUFDNUIsZ0RBQWdEO0FBU2hEOztHQUVHO0FBRUksSUFBTSxvQkFBb0IsR0FBMUIsTUFBTSxvQkFBcUIsU0FBUSxnQkFBVTtJQUE3Qzs7UUFNMkIsYUFBUSxHQUEyQixFQUFFLENBQUE7SUEyQnZFLENBQUM7SUF6QkMsTUFBTTtRQUNKLE9BQU8sSUFBQSxVQUFJLEVBQUE7O1VBRUwsSUFBSSxDQUFDLFFBQVEsQ0FBQyxHQUFHLENBQ2pCLE9BQU8sQ0FBQyxFQUFFLENBQUMsSUFBQSxVQUFJLEVBQUE7O3dCQUVELE9BQU8sQ0FBQyxPQUFPOzRCQUNYLE9BQU8sQ0FBQyxXQUFXO3FCQUMxQixtQkFBVSxDQUFDLElBQUk7O2dCQUVwQixJQUFJLENBQUMsV0FBVyxDQUFDLE9BQU8sQ0FBQyxLQUFLLENBQUM7O1dBRXBDLENBQ0Y7O0tBRUosQ0FBQTtJQUNILENBQUM7SUFFTyxXQUFXLENBQUMsS0FBZ0I7UUFDbEMsSUFBSSxDQUFDLEtBQUssRUFBRSxNQUFNO1lBQUUsT0FBTyxhQUFPLENBQUE7UUFFbEMsT0FBTyxJQUFBLFVBQUksRUFBQTs2QkFDYyxLQUFLO0tBQzdCLENBQUE7SUFDSCxDQUFDOztBQS9CTSwyQkFBTSxHQUFHLElBQUEsU0FBRyxFQUFBOzs7O0dBSWxCLENBQUE7QUFDK0I7SUFBL0IsSUFBQSx3QkFBUSxFQUFDLEVBQUUsU0FBUyxFQUFFLEtBQUssRUFBRSxDQUFDO3NEQUFzQztBQU4xRCxvQkFBb0I7SUFEaEMsSUFBQSw2QkFBYSxFQUFDLDJCQUEyQixDQUFDO0dBQzlCLG9CQUFvQixDQWlDaEM7QUFqQ1ksb0RBQW9CIn0=